var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__a",
    x1: "3.772%",
    x2: "89.946%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#808FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5566D6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 8,
    r: 7,
    fill: "url(#prefix__a)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFF",
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: 11,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 3.5,
    y: 12
  }, "D")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD);
export default __webpack_public_path__ + "static/media/d.f667af6cee1420a7238716f08812859a.svg";
export { ForwardRef as ReactComponent };